import type { EventEditFormValues } from '-/Event/EventEdit.types';
import { useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import EventEditTeamListItem from '@/components/Event/EventEditTeamListItem';
import Box from '@/components/UI/Box';
import EntityListInput from '../Entity/EntityListInput';

export default function EventEditTeamList() {
  const { setValue, getValues, control } =
    useFormContext<EventEditFormValues>();

  const teams = useWatch({ name: 'teams', control });
  const eventType = useWatch({ name: 'eventType', control });
  const [menuIndex, setMenuIndex] = useState<number | null>(null);

  return (
    <Box direction="vertical">
      {teams?.map((team, index) => {
        if (team.isNew && eventType !== 'game') {
          return (
            <EntityListInput
              name="teams"
              key={team.id}
              index={index}
              isMenuOpen={menuIndex === index}
              setMenuIndex={setMenuIndex}
            />
          );
        }
        return (
          <EventEditTeamListItem
            getValues={getValues}
            setValue={setValue}
            key={team.id}
            index={index}
            team={team}
            isGame={eventType === 'game' && teams.length === 2}
          />
        );
      })}
    </Box>
  );
}
